export const loadLib=(url, idTag)=>{
    return new Promise((resolve, reject) => {
      globalThis.idTagDelio = idTag;
      const script = globalThis.document.createElement("script");
      script.src = url;
      script.id = "initWalmeric";
      script.async = true;
      script.onload = () => {
        let timeKill=setTimeout(()=>{
            clearTimeout(timeKill)
            resolve(true); // Carga
          },1200)
    };
      script.onerror = reject; // No carga
      document.head.appendChild(script);
    });
}

export const getUrlVar = function (variable, url) {
  var href = url || window.location.search;
  var i, pair;
  var query = href.split("?")[1];
  var vars = query ? query.split("&") : [];

  for (let i = 0; i < vars.length; i++) {
    pair = vars[i].split("=");
    // Comprobar si el nombre de la variable coincide y si el valor no es undefined o null
    if (pair[0] === variable) {
      return pair[1] ? decodeURIComponent(pair[1]) : ""; // Devuelve el valor decodificado o vacío
    }
  }

  return ""; // Si no se encuentra la variable, devuelve vacío
};
  